import React, { useEffect } from 'react';
import NavigationBar from "./components/NavigationBar";
import Footer from "./components/Footer";
import './globals.css';

const BoardMembers = () => {
  useEffect(() => {
    document.title = "IWPFI2026_Board Members";
  }, []);
  return (
    <div id="everything">
      <NavigationBar />

      <main className="page-board">
        <section className="board-section">
          <h1 className="board-title">IWPFI Board Members</h1>
          <p className="board-intro">
            The IWPFI Board provides leadership, vision, and continuity for the International Workshop on 
            Pulmonary Functional Imaging.
          </p>
        </section>

        <section className="board-section">
          <div className="board-grid">
            {/* Chair */}
            <div className="board-card">
              <div className="board-role">Chair</div>
              <div className="board-name">David Lewis Levin</div>
              <div className="board-affiliation">Stanford University</div>
              <div className="board-location">Stanford, USA</div>
            </div>

            {/* Past Chair */}
            <div className="board-card">
              <div className="board-role">Past Chair</div>
              <div className="board-name">Joon Beom Seo</div>
              <div className="board-affiliation">
                University of Ulsan College of Medicine, Asan Medical Center
                </div>
              <div className="board-location">Seoul, Korea</div>
            </div>

            {/* Vice Chair */}
            <div className="board-card">
              <div className="board-role">Vice Chair</div>
              <div className="board-name">Jens Vogel-Claussen</div>
              <div className="board-affiliation">University of Hannover</div>
              <div className="board-location">Hannover, Germany</div>
            </div>

            {/* Secretary General */}
            <div className="board-card">
              <div className="board-role">Secretary General</div>
              <div className="board-name">Yasatuka Nakano</div>
              <div className="board-affiliation">Shiga University of Medical Science</div>
              <div className="board-location">Shiga, Japan</div>
            </div>

            {/* Meeting President */}
            <div className="board-card">
              <div className="board-role">Meeting President</div>
              <div className="board-name">Grace Parraga</div>
              <div className="board-affiliation">
                Robarts Research Institute, The University of Western Ontario
              </div>
              <div className="board-location">London, Canada</div>
            </div>

            {/* Vice President */}
            <div className="board-card">
              <div className="board-role">Vice President</div>
              <div className="board-name">Jim Wild</div>
              <div className="board-affiliation">University of Sheffield</div>
              <div className="board-location">Sheffield, UK</div>
            </div>

            {/* Vice President-elect */}
            {/* <div className="board-card">
              <div className="board-role">Vice President-elect</div>
              <div className="board-name">Grace Parraga</div>
              <div className="board-affiliation">
                Robarts Research Institute, The University of Western Ontario
              </div>
              <div className="board-location">London, Canada</div>
            </div> */}
          </div>
        </section>
        <div className="footer-logo">
          <img src="/images/iwpfi_horizontal_logo.jpg" alt="Logo" />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default BoardMembers;
